export const AUTH_PROXY_REDIRECT_TARGET_COOKIE = 'auth-proxy-redirect-target';

export const PREVIEW_DOMAIN_SUFFIX = '.preview.openbraininstitute.org';
